module.exports = __webpack_public_path__ + "img/d14.1a88e1f1.png";